import { initialState } from './slice';

export const travelRequirementsDTO = (
  data: unknown,
): { title: string; link: string } => {
  if (data !== null && typeof data === 'object') {
    return {
      title:
        'title' in data && typeof data.title === 'string'
          ? data.title
          : initialState.title,
      link:
        'link' in data && typeof data.link === 'string'
          ? data.link
          : initialState.link,
    };
  }
  return initialState;
};
